/**
 * Used for storing the redirect url during login as a query parameter
 * in the route of the application.
 */
export const redirectDestinationName = 'rd';
